import i18n from '@/plugins/i18n.js'
import api from '@/script/api.js'

export default {
  async setUser({ commit, getters }) {
    let userId = getters.userId

    if (!userId) return

    const res = await api.getUserDetails(userId)

    if (!res || res.status !== 200) {
    } else {
      commit('SET_USER_ACCOUNT_INFORMATION', res.data)
      commit('SET_OWNERS', res.data)
      return res.data
    }
  },

  async getShootings({ commit, dispatch }, payload) {
    const { userId, startDate, endDate, registration, types } = payload

    const snackMessage = i18n.t('api.getShootingsError')
    const messageType = 'error'
    let shootings

    commit('TOGGLE_LOADING', true)

    shootings = await api.getShootings(userId, 0, 12, startDate, endDate, registration, types)

    if (!shootings || shootings.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessage, color: messageType })
      commit('TOGGLE_LOADING', false)
    } else {
      commit('GET_SHOOTINGS', shootings.data)
      commit('SAVE_PREV_CALL_SEARCH')
    }

    return true
  },

  async researchShooting({ commit, dispatch }, payload) {
    const { userId, startDate, endDate, registration, types } = payload
    const snackMessage = i18n.t('api.researchShootingError')
    const messageType = 'error'
    let shootings, owners

    commit('TOGGLE_LOADING', true)

    shootings = await api.getShootings(userId, 0, 12, startDate, endDate, registration, types)

    if (!shootings || shootings.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessage, color: messageType })
      commit('TOGGLE_LOADING', false)
    } else {
      commit('GET_SHOOTINGS', shootings.data)
      commit('SAVE_PREV_CALL_SEARCH')
    }
  },

  async getShootingsInformations({ commit }, payload) {
    const { ownerId, productId } = payload
    const snackMessage = i18n.t('api.getShootingsInformationsError')
    const messageType = 'error'

    const shootingInfo = await api.getShootingsInformations(ownerId, productId)

    if (!shootingInfo || shootingInfo.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessage, color: messageType })
      commit('GET_SHOOTING_INFORMATION', null)
      return null
    } else {
      commit('GET_SHOOTING_INFORMATION', shootingInfo.data)
      return shootingInfo.data
    }
  },

  async getShooting({ commit }, payload) {
    const { ownerId, productId, shootingId } = payload
    const snackMessage = i18n.t('api.getShootingError')
    const messageType = 'error'

    commit('RESET_SHOOTING')
    commit('TOGGLE_LOADING', true)

    const shooting = await api.getShooting(ownerId, productId, shootingId)

    if (!shooting || shooting.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessage, color: messageType })
      commit('TOGGLE_LOADING', false)
    } else {
      commit('ADD_SHOOTING', shooting.data.images)
      commit('ADD_SHOOTING_USER_INFORMATION', shooting.data.user)
      commit('ADD_SHOOTING_STATUS', shooting.data.remarketingShootingStatus)
      commit('ADD_STAMPS', shooting.data.model?.stamps)
      commit('ADD_SHOOTING_CREATION_DATE', shooting.data.created)
      if (shooting.data.videos.length !== 0) {
        let result
        const types = ['CONCAT_AUDIO', 'ORIGINAL_AUDIO', 'CONCAT', 'ORIGINAL']
        for (let i = 0; i < types.length; i++) {
          const type = types[i]
          result = shooting.data.videos.find(el => el.type === type)

          if (result) {
            commit('ADD_VIDEO', result)
            return true
          }
        }
      }
    }

    return true
  },

  async getVideo({ commit }, payload) {
    const { ownerId, productId, shootingId } = payload
    const snackMessage = i18n.t('api.getVideoError')

    const video = await api.getVideo(ownerId, productId, shootingId)

    if (!video || video.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessage, color: 'error' })
    } else {
      if (video.data.length !== 0) {
        let result
        const types = ['CONCAT_AUDIO', 'ORIGINAL_AUDIO', 'CONCAT', 'ORIGINAL']
        for (let i = 0; i < types.length; i++) {
          const type = types[i]
          result = video.data.find(el => el.type === type)

          if (result) {
            commit('ADD_VIDEO', result)
            return true
          }
        }
      }
    }
    return true
  },

  async getProducts({ commit, dispatch }) {
    const snackMessage = i18n.t('api.getProductsError')
    const messageType = 'error'
    let products, owners

    commit('TOGGLE_LOADING', true)

    owners = await dispatch('setUser')

    products = await api.getProducts(owners)

    if (products.status.indexOf('200') !== -1) {
      commit('SET_SNACKBAR', { snack: snackMessage, color: messageType })
      commit('TOGGLE_LOADING', false)
    } else {
      commit('GET_PRODUCTS', products.data)
    }

    return true
  },

  async sharedPlayerStatistics({ commit }, payload) {
    const { userId, marketplaceProductRef, data } = payload

    return await api.sharedPlayerStatistics(userId, marketplaceProductRef, data)
  },

  async sendEmailStatsForLive({ commit }, payload) {
    const { userId, videoId } = payload

    return await api.sharedLiveVideoStatistics(userId, videoId)
  },

  async loadMoreShootings({ commit }, payload) {
    const { userId, offset, limit, startDate, endDate, registration, types } = payload
    const snackMessageError = i18n.t('api.loadMoreShootingsError')
    const snackMessageInfo = i18n.t('api.loadMoreShootingsInfo')
    const messageTypeError = 'error'
    const messageTypeInfo = 'info'

    const shootings = await api.getShootings(userId, offset, limit, startDate, endDate, registration, types)

    if (!shootings || shootings.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: messageTypeError })
    } else if (shootings.data.length === 0) {
      commit('SET_SNACKBAR', { snack: snackMessageInfo, color: messageTypeInfo })
    } else {
      commit('ADD_SHOOTINGS', shootings.data)
    }

    return true
  },

  async getLabelOwner({ commit, dispatch }, ownersId) {
    const snackMessage = i18n.t('api.getLabelOwnerError')
    const messageType = 'error'
    let res, owners

    commit('TOGGLE_LOADING', true)

    if (!ownersId || ownersId.length === 0) {
      owners = await dispatch('setUser')
    }
    res = await api.getLabelOwner(owners || ownersId)

    if (!res || res.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessage, color: messageType })
      commit('TOGGLE_LOADING', false)
      return false
    } else {
      commit('GET_LABEL_OWNER', res.data)
    }

    return true
  },

  async createVirtualProduct({ commit }, payload) {
    const { ownerId, registration, uuid } = payload
    const snackMessage = i18n.t('api.createVirtualProductError')
    const messageType = 'error'

    const res = await api.createVirtualProduct(ownerId, registration, uuid)

    if (!res || res.status !== 201) {
      commit('SET_SNACKBAR', { snack: snackMessage, color: messageType })
      return false
    } else {
      return res.data.id
    }
  },

  async generatePresignedUrl({ commit }, payload) {
    const { productId, picturesList } = payload
    const snackMessageError = i18n.t('api.generatePresignedUrlError')

    const res = await api.generatePresignedUrl(productId, picturesList)

    if (!res || res.status !== 201) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
    }

    return res.data
  },

  async putImageOnS3({ commit }, payload) {
    const { presignedUrl, file, url, order } = payload
    const snackMessageError = i18n.t('api.putImageOnS3Error')

    const res = await api.putImageOnS3(presignedUrl, file)

    if (!res || res.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    }

    return { ...res, url, order }
  },

  async setImagesfromBucket({ commit }, payload) {
    const { ownerId, productId, data } = payload

    const res = await api.setImagesfromBucket(ownerId, productId, data)

    if (!res || res.status !== 201) {
      return false
    } else {
      return true
    }
  },

  async getStamps({ commit }, payload) {
    const { userId, format } = payload
    const snackMessageError = i18n.t('api.getStampsError')

    const res = await api.getStamps(userId, format)

    if (!res || res.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return true
    } else {
      commit('GET_STAMPS', res.data)
      return true
    }
  },

  async sendStampShooting({ commit }, payload) {
    const snackMessageError = i18n.t('api.sendStampShootingError')
    const { ownerId, productId, shootingId, data } = payload

    const res = await api.sendStampShooting(ownerId, productId, shootingId, data)

    if (!res || res.status !== 202) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      return true
    }
  },

  async deleteShooting({ commit }, payload) {
    const { ownerId, productId, shootingId } = payload

    const res = await api.deleteShooting(ownerId, productId, shootingId)

    const notification = {
      error: {
        snack: i18n.t('api.deleteShootingError'),
        color: 'error'
      },
      success: {
        snack: i18n.t('api.deleteShootingSuccess'),
        color: 'success'
      }
    }
    const notificationType = res ? 'success' : 'error'
    commit('SET_SNACKBAR', notification[notificationType])
  },

  async deleteVideo({ commit }, payload) {
    const snackMessageError = i18n.t('api.deleteVideoError')
    const snackMessageSuccess = i18n.t('api.deleteVideoSuccess')

    const { ownerId, productId, shootingId } = payload

    const res = await api.deleteVideo(ownerId, productId, shootingId)

    if (!res || res.status !== 204) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'success' })
      return true
    }
  },

  async replayDMS({ commit }, shootingId) {
    const snackMessageError = i18n.t('api.replayDMSError')
    const snackMessageSuccess = i18n.t('api.replayDMSSuccess')

    const res = await api.replayDMS(shootingId)

    if (!res || res.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return true
    } else {
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'success' })
      return true
    }
  },

  async getPlayerInformations({ commit }, shootingId) {
    const snackMessageError = i18n.t('api.getReferenceError')

    const res = await api.getPlayerInformations(shootingId)

    if (!res || res.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      return res.data
    }
  },

  async sendEmail({ commit }, payload) {
    const snackMessageError = i18n.t('api.sendEmailError')
    const snackMessageSuccess = i18n.t('api.sendEmailSuccess')

    const res = await api.sendNotification(payload, 'EMAIL')

    if (!res || res.status !== 204) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'success' })
      return true
    }
  },

  async sendSms({ commit }, payload) {
    const snackMessageError = i18n.t('api.sendSmsError')
    const snackMessageSuccess = i18n.t('api.sendSmsSuccess')

    const { status } = await api.sendNotification(payload, 'SMS')

    if (status !== 204) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'success' })
      return true
    }
  },

  async validWorkflow({ commit }, payload) {
    let res
    const { ownerId, productId } = payload

    const snackMessageError = i18n.t('api.setImagesfromBucketError')
    const snackMessageSuccess = i18n.t('api.setImagesfromBucketSuccess')

    res = await api.validWorkflow(ownerId, productId)

    if (!res || res.status !== 204) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'success' })
      return true
    }
  },

  async createRoomLive({ commit }, payload) {
    let res

    const snackMessageError = i18n.t('api.createRoomLiveError')
    const snackMessageSuccess = i18n.t('api.createRoomLive')

    res = await api.createRoomLive(payload)

    if (!res || res.status !== 201) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'success' })
      return true
    }
  },

  async getTokenRoomLive({ commit }, payload) {
    const { userId, roomName } = payload
    let res

    const snackMessageError = i18n.t('api.getTokenRoomLiveError')

    res = await api.getTokenRoomLive(userId, roomName)

    if (!res || res.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      return res.data.access_token
    }
  },

  async getRoomLive({ commit }, payload) {
    let res

    const snackMessageError = i18n.t('api.getRoomLiveError')

    commit('TOGGLE_LOADING', true)

    res = await api.getRoomLive(payload)

    if (!res || res.status !== 200) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      commit('TOGGLE_LOADING', false)
      return false
    } else {
      commit('GET_ROOMS', res.data)
      commit('TOGGLE_LOADING', false)
      return true
    }
  },

  async getUserOptions({ commit }, userId) {
    if (!userId) return

    const res = await api.getUserOptions(userId)

    if (!res || res.status !== 200) {
      return
    } else {
      commit('USER_OPTIONS', res.data)
    }
  },

  async getRoomInformations({ commit }, idLiveVideo) {
    commit('TOGGLE_LOADING', true)

    const res = await api.getRoomInformations(idLiveVideo)

    if (!res || res.status !== 200) {
      commit('TOGGLE_LOADING', false)
      return false
    } else {
      commit('GET_ROOM_INFORMATION', res.data)
      commit('TOGGLE_LOADING', false)
      return true
    }
  },

  async notificationVideo({ commit }, payload) {
    const res = await api.postNotificationVideo(payload)

    if (!res || res.status !== 200) {
      return false
    } else {
      return true
    }
  },

  async shootingOptions({ commit }, payload) {
    const { id, page } = payload

    commit('TOGGLE_LOADING_CUSTOM_BRAND', true)
    const res = page === 'Player' ? await api.shootingOptions(id) : await api.getLogoFromRoomLive(id)

    if (!res || res.status !== 200) {
      commit('TOGGLE_LOADING_CUSTOM_BRAND', false)
      commit('TOGGLE_LOADING_CUSTOM_BRAND_FIRST_LOAD')
      return false
    } else {
      commit('TOGGLE_LOADING_CUSTOM_BRAND', false)
      commit('TOGGLE_LOADING_CUSTOM_BRAND_FIRST_LOAD')

      if (res.data && res.data.logo && res.data.logo !== '') {
        commit('CUSTOM_BRAND_LOGO', res.data.logo)
      }
      commit('CONTACT_INFORMATIONS', res.data.contactInformations)
      return res.data
    }
  },

  async sendPlayerRating({ commit }, payload) {
    let res
    const { from, data } = payload
    const snackMessageSuccess = i18n.t('api.ratingSuccess')
    const snackMessageError = i18n.t('api.ratingError')

    switch (from) {
      case 'Player':
        res = await api.playerRating(data)
        break
      case 'LiveVideo':
        res = await api.liveVideoRating(data)
        break
      default:
        return
    }

    if (!res || res.status !== 201) {
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' })
      return false
    } else {
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'primary' })
      return true
    }
  },

  async getStampConfiguration({ commit }, originalImages) {
    let originalImagesWithStampConfiguration = []
    if (!originalImages || originalImages === 0) return

    for (let i = 0; i < originalImages.length; i++) {
      const originalImage = originalImages[i]
      const originalImageStampId = originalImage.stampId

      if (!originalImageStampId) return originalImagesWithStampConfiguration

      const stampConfiguration = await api.getStampConfiguration(originalImage.stampId)

      originalImagesWithStampConfiguration.push({
        image: originalImage,
        configuration: stampConfiguration.data
      })
    }

    return originalImagesWithStampConfiguration
  },

  async getLicensePlateCoverForImage({ commit }, imagesWithConfiguration) {
    let newArray = []
    let listUrl = {
      list_url: []
    }

    for (let i = 0; i < imagesWithConfiguration.length; i++) {
      const element = imagesWithConfiguration[i]
      newArray.push({
        url: element.image.url,
        ref: element.image.id
      })
    }

    listUrl.list_url = newArray

    // get license plate cover position
    const res = await api.getLicensePlateCoverForImage(listUrl)

    for (let j = 0; j < imagesWithConfiguration.length; j++) {
      const el = imagesWithConfiguration[j]

      for (let k = 0; k < res.data.length; k++) {
        const element = res.data[k]

        if (el.image.id === element.ref) {
          imagesWithConfiguration[j] = {
            ...imagesWithConfiguration[j],
            licensePlateCoverPositionResponse: element
          }
        }
      }
    }

    return imagesWithConfiguration
  },

  async applyLicensePlateCoverPositionOnImage({ commit }, payload) {
    const { imagesWithLicensePlatePosition, shootingId } = payload

    for (let i = 0; i < imagesWithLicensePlatePosition.length; i++) {
      const element = imagesWithLicensePlatePosition[i].licensePlateCoverPositionResponse
      // Apply license plate cover
      if (element && element.error) {
        imagesWithLicensePlatePosition[i] = {
          ...imagesWithLicensePlatePosition[i],
          applyPositionResponse: element.error
        }
      } else {
        const res = await api.applyLicensePlateCoverPositionOnImage(shootingId, element.ref, element.licencePlateCover)
        imagesWithLicensePlatePosition[i] = {
          ...imagesWithLicensePlatePosition[i],
          applyPositionResponse: res
        }
      }
    }

    return imagesWithLicensePlatePosition
  },

  async croppedImagesSelected({ commit }, originalImagesWithStampConfiguration) {
    let newImages = []

    function formatImages(image) {
      const hasConfiguration = image.configuration && image.configuration.croppingConfiguration
      if (!hasConfiguration) return

      return {
        backgroundUrl: image.configuration.croppingConfiguration.background,
        blurringValue: image.configuration.croppingConfiguration.blurringValue,
        url: image.image.url,
        order: image.image.order,
        reference: image.image.id
      }
    }

    const timer = ms => new Promise(res => setTimeout(res, ms))

    for (let i = 0; i < originalImagesWithStampConfiguration.length; i++) {
      let res
      const image = originalImagesWithStampConfiguration[i]
      const imageFormated = formatImages(image)

      if (imageFormated) {
        const croppingType = image.configuration.croppingConfiguration.croppingType

        res = await api.croppedImage(imageFormated, croppingType)
        await timer(1000)
      }

      if (res && res.status === 200) {
        newImages.push({ image, croppingResult: res && res.data })
      }
    }

    return newImages
  },

  async stampImages({ commit }, images) {
    let newData = {
      stampId: null,
      images: []
    }

    images.forEach(element => {
      const hasUrl = element.croppingResult && element.croppingResult.urlWithBackground
      const stampId = element.image.configuration && element.image.configuration.id

      if (hasUrl && stampId) {
        newData.stampId = stampId
        newData.images.push({ name: element.image.image.id, url: element.croppingResult.urlWithBackground })
      }
    })

    if (!newData.stampId || newData.images.length === 0) {
      return (images = {
        images: [...images],
        stampedImages: null
      })
    } else {
      const res = await api.stampImages(newData)

      images = {
        images: [...images],
        stampedImages: res && res.data
      }
    }

    return images
  },

  async addImagesShooting({ commit }, payload) {
    const { shootingId, imageInformations } = payload
    const imageList = imageInformations.images

    let data = {
      images: []
    }

    if (imageList.length === 0)
      return {
        data: imageInformations,
        res: null
      }

    imageList.forEach(element => {
      if (!element.croppingResult || (element.croppingResult && element.croppingResult.code)) return

      const arr = [
        {
          url: element.croppingResult.urlWithBackground,
          type: 'BACKGROUND_CROPPED'
        },
        {
          url: element.croppingResult.urlWithoutBackground,
          type: 'ORIGINAL_CROPPED'
        },
        {
          url: element.croppingResult.urlWithoutBackgroundNoShadow,
          type: 'ORIGINAL_CROPPED_NO_SHADOW'
        },
        {
          url: null,
          type: 'STAMPED_CROPPED'
        }
      ]

      const stampedImages = imageInformations.stampedImages

      const oscImage = stampedImages.find(e => e.name === element.image.image.id)
      arr[3].url = oscImage.url

      for (let i = 0; i < arr.length; i++) {
        const { url, type } = arr[i]

        const el = {
          url: url,
          order: element.image.image.order,
          imageType: type,
          maskId: element.image.image.maskId,
          stampId: element.image.image.stampId,
          format: element.image.image.format
        }

        data.images.push(el)
      }
    })

    const res = data.images.length > 0 && (await api.addImagesToShooting(shootingId, data))

    return {
      imageInformations,
      imagesAdded: res && res.data
    }
  },

  async getStampsFromStampotheque({ commit }, userId) {
    const res = await api.getStampsFromStampotheque(userId)

    if (res.status === 200) {
      commit('UPDATE_STAMPS', res.data)
    }

    return res
  },

  async advaloremVerification({ commit }, payload) {
    const { shootingId, userId, data, type } = payload
    let body

    if (type === 'CROPPING' || type === 'PARTIAL_CROPPING' || type === 'FADED_CROPPING') {
      body = formatDataCropping(shootingId, userId, data)
      for (let i = 0; i < body.length; i++) {
        const e = body[i]
        await api.advaloremVerificationCropping(e.shootingId, e.imageId, e.inputBody)
      }
    } else {
      body = formatDataLicencePlateCover(shootingId, userId, data)
      for (let i = 0; i < body.length; i++) {
        const e = body[i]
        await api.advaloremVerification(e.shootingId, e.imageId, e.inputBody)
      }
    }

    function formatDataCropping(shootingId, userId, data) {
      let body = []

      data.imageInformations.images.forEach(e => {
        const image = e.image.image
        const imageConfiguration = e.image.configuration
        const originalCroppedImages = data.imagesAdded && data.imagesAdded.backgroundsCropped

        if (!!originalCroppedImages) {
          const croppingUrl = findImageUrlCropped(originalCroppedImages, e)

          if (!!croppingUrl) {
            const inputBody = {
              userId: userId,
              imageId: image.id,
              stamp_id: image.stampId,
              shootingId: shootingId,
              cropping_type: imageConfiguration.croppingConfiguration.croppingType,
              url: image.url,
              cropped_url: croppingUrl,
              order: image.order
            }

            body.push({
              shootingId: shootingId,
              imageId: image.id,
              inputBody
            })
          }
        }
      })

      return body
    }

    function findImageUrlCropped(originalCroppedImages, e) {
      let croppedUrl

      originalCroppedImages.forEach(f => {
        if (f.order === e.image.image.order) {
          croppedUrl = e.croppingResult.urlWithBackground
        }
      })

      return croppedUrl
    }

    function formatDataLicencePlateCover(shootingId, userId, data) {
      let body = []

      data.forEach(e => {
        const image = e.image
        // covered image url = 1ere ORIGINAL_LPC
        if (e.applyPositionResponse && e.applyPositionResponse.status === 200) {
          const inputBody = {
            userId: userId,
            order: image.order,
            originalImageUrl: image.url,
            coveredImageUrl: e.licensePlateCoverPositionResponse.url,
            coordinates: e.licensePlateCoverPositionResponse.licencePlateCover
          }

          body.push({
            shootingId: shootingId,
            imageId: image.id,
            inputBody
          })
        }
      })

      return body
    }
  }
}
